/**
 * The minimum viewport, settled in M5 Phase 1 and measured rather than assumed.
 *
 * At 1280 the status row's groups and the commit button still lay out with the
 * flex spacer at its 12 px floor and nothing elided. `ConsoleShell` sets a hard
 * `min-width` **and** a hard `min-height`, so a smaller window scrolls on either
 * axis rather than reflowing the chrome into an unreadable shape.
 *
 * ## The chrome budget, revised in the design pass after M5
 *
 * The identity row grew from 32 px to 52 px, because shell.md asks it to be
 * readable across the room and a 20 px crest with an 11 px side name was not —
 * the two teams' consoles were indistinguishable past about a metre. So the
 * fixed bands are 172 px, not 152 px, and 720 leaves **548 px** of centre pane.
 *
 * That figure used to read 568 and was described as what MW's timeline dock
 * needs. The dock is 122 px (`mw/TimelineDock.tsx`), nothing enforced 568 in
 * code, and no test asserted it; it was a measurement of what happened to be
 * left over. Twenty of those pixels now do a job the design document asked for
 * and the console was not doing.
 *
 * It lives in its own module because Phase 2's rail clamp is computed against it
 * (`model/rails.ts`) and the model layer may not import a component.
 */
export const CONSOLE_MIN_VIEWPORT = Object.freeze({ width: 1280, height: 720 });
